import type { CommunityDetail } from '@pba/react-network';
import { type ReactNode, useMemo } from 'react';
import { Icon } from 'ui';

export type PrivacyInformation = {
  description: string;
  icon: ReactNode;
  name: string;
};

type P = {
  privacy: CommunityDetail['privacy'];
};

export const useGetCommunityPrivacyInformation = ({ privacy }: P): PrivacyInformation =>
  useMemo(() => {
    switch (privacy) {
      case 'private':
        return { description: 'Members must request to join', icon: <Icon icon="lock-line" />, name: 'Private' };
      case 'public':
        return { description: 'Any member can join', icon: <Icon icon="earth-line" />, name: 'Public' };
      case 'secret':
        return {
          description: 'Member must be invited to be able to join',
          icon: <Icon icon="mail-line" />,
          name: 'Secret',
        };
    }
  }, [privacy]);
